module.exports = __webpack_public_path__ + "img/accessory_item_01.fa65d5c9.svg";